<template>
    <div v-if="reading">
        <qrcode-stream @decode="onDecode"></qrcode-stream>
        <qrcode-drop-zone></qrcode-drop-zone>
        <!-- <qrcode-capture></qrcode-capture> -->
    </div>
</template>
<script>
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader';
export default {
    components: {
        QrcodeStream,
        QrcodeDropZone,
        QrcodeCapture
    },
    data: () => ({
        reading: false
    }),
    methods: {
        read() {
            this.reading = true;
        },
        off() {
            this.reading = false;
        },
        onDecode(decodeString) {
            this.$emit('read', decodeString);
        }
    }
}
</script>